
import React from 'react';

interface ComplianceProgressBarProps {
  complianceBefore: number;
  complianceImprovement: number;
}

export const ComplianceProgressBar = ({ 
  complianceBefore, 
  complianceImprovement 
}: ComplianceProgressBarProps) => {
  return (
    <div className="p-4">
      <div className="mb-2 flex justify-between items-center">
        <div className="text-sm font-medium">Compliance Score Impact</div>
        <div className="text-sm font-medium">+{complianceImprovement}%</div>
      </div>
      <div className="flex items-center gap-4">
        <div className="w-full bg-muted rounded-full h-4 overflow-hidden">
          <div className="relative w-full h-full">
            <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700"></div>
            <div 
              className="absolute inset-0 bg-primary transition-all duration-1000 ease-out"
              style={{ width: `${complianceBefore}%` }}
            ></div>
            <div 
              className="absolute inset-0 left-auto bg-green-500 transition-all duration-1000 ease-out"
              style={{ width: `${complianceImprovement}%` }}
            ></div>
          </div>
        </div>
      </div>
      <div className="flex justify-between text-xs text-muted-foreground mt-1">
        <span>Before</span>
        <span>After</span>
      </div>
    </div>
  );
};
